var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"studio-product-content"},[_c('div',{staticClass:"row mt-5"},_vm._l((_vm.sortedPlaylistContent),function(media){return _c('div',{key:media.id,staticClass:"column col-6 col-md-4 col-lg-3 mt-2"},[_c('router-link',{staticClass:"undecorated-router-link",attrs:{"to":_vm.getCorrectRoute({
            playlist_id: _vm.playlist.id,
            media_id: media.id,
            isMediaLocked: media.media.locked,
          })}},[_c('StudioMediaCard',{attrs:{"product":_vm.product,"media":media}})],1)],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }